import React from 'react';
import { useT } from 'client/i18n/hooks/useT';
import SuccessButton from '../SuccessButton';
import styles from './styles.sass';

export function RequestResetPasswordConfirmation({ clickLogIn }) {
  const t = useT();

  const handleClickLogIn = evt => {
    evt.preventDefault();
    clickLogIn();
  };

  return (
    <div>
      <p className="text-center">
        {t(
          'RequestResetPasswordConfirmation.Header',
          'Email sent!',
          'Reset password email sent confirmation header'
        )}
      </p>
      <SuccessButton
        className={styles.successIcon}
        bgColor="#5000b9"
        fgColor="#ffffff"
      />
      <p className="text-center">
        {t(
          'RequestResetPasswordConfirmation.Message',
          'Click the link in the email we sent to finish resetting your password.',
          'Reset password email sent confirmation message'
        )}
      </p>
      <p className={`text-center ${styles.loginFooter}`}>
        <a href onClick={handleClickLogIn}>
          {t(
            'RequestResetPasswordConfirmation.ReturnToLoginLinkText',
            'Return to login',
            'Return to login page link text'
          )}
        </a>
      </p>
    </div>
  );
}
